export const exhaustiveCheck = (value: never) => value;
